import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { colors } from "../../../Shared/colors";
import { DataGrid } from "@mui/x-data-grid";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import StarIcon from "@mui/icons-material/Star";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ShareIcon from "@mui/icons-material/Share";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useGetAllLeadsQuery, useShareLeadMutation } from "../../../features/leadsSlice";
import {
  useAddFavouriteMutation,
  useGetSingleHierarchyQuery,
  useGetActiveStaffQuery,
} from "../../../features/employeeSlice";
import { Toaster, toast } from "react-hot-toast";
import { Loader } from "../../../Shared/Loader";
import { Puff } from "react-loader-spinner";
import {
  useGetAllProjectsQuery,
  useGetSingleProjectQuery,
} from "../../../features/projectSlice";
import { useLazyGetInventoryByProjectIdQuery } from "../../../features/InventorySlice";
import { useAddNewTaskLeadIdMutation } from "../../../features/taskSlice";
import { TaskTable } from "./TaskTable";
import Tooltip from "@mui/material/Tooltip";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Banks } from "../../../Shared/Banks";
import moment from "moment";
import { decryptData } from "../../../services/crypto";
import { UnifiedTaskTable } from "../../Telesales/Telesaleleads/Telesalesearchleads/UnifiedTaskTable";

export const ManageLeadsDataTable = ({ leads, isFetching, pageSize, setPageSize, setPage }) => {
  const [popUp, setpopUp] = useState(false);
  const [leadId, setleadId] = useState("");
  const [leadNumber, setLeadNumber] = useState("");
  const [subType, setsubType] = useState();

  const [tokenDownPayment, settokenDownPayment] = useState(false);

  const [loading, setloading] = useState(false);

  const [closedLost, setclosedLost] = useState(false);

  const [addTask, { isLoading }] = useAddNewTaskLeadIdMutation();

  const [taskPopUp, setTaskPopUp] = useState(false);

  const [leadSharePopUp, setleadSharePopUp] = useState(false);

  const [leadShareData, setleadShareData] = useState({
    sharingEmployee: { label: "", id: "" },
    percentage: ""
  })

  const [numberPopUp, setnumberPopUp] = useState(false);

  const [phoneData, setphoneData] = useState([]);

  const [doNothing, setdoNothing] = useState(false);

  const [maxDate, setmaxDate] = useState("");

  const [minDate, setminDate] = useState("");

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        setpopUp(false);
        setTaskPopUp(false);
        setnumberPopUp(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  // const today = new Date();
  // const numberOfDaysToAdd = 0;
  // const date = today.setDate(today.getDate() + numberOfDaysToAdd);
  // const defaultDate = new Date(date).toISOString().split("T")[0];
  const today = moment();
  const defaultDate = today.format('YYYY-MM-DDTHH:mm');
  const newMinDate = today.clone().subtract(1, 'days').format('YYYY-MM-DDTHH:mm');

  useEffect(() => {
    setminDate(newMinDate);
  }, [newMinDate]);

  useEffect(() => {
    setmaxDate(defaultDate);
  }, [defaultDate]);
  const [selectedProject, setSelectedProject] = useState("");
  const [task, settask] = useState({
    currentTaskType: "",
    currentSubTypeTask: "",
    completedDate: defaultDate,
    reason: "",
    comment: "",
    nextTaskType: "",
    deadline: "",
    DProjectID: "",
    DTprojectBlockName: "",
    invenID: "",
    ammount: 0,
    paymentMode: "",
    bankName: "",
    transactionNo: 0,
    totalAmount: 0,
    depositeDate: "",
    status: "",
    attachment: "",
    approvedPayment: "",
    leadId: "",
    developername: "",
    cnicfront: "",
    cnicback: "",
    personalimage: "",
    clientId: "",
    clientname: "",
    cnic: "",
    phoneNo: "",
    nationality: "",
    address: "",
    leadStatus: "",
  });

  let { data: project } = useGetAllProjectsQuery();

  let { data: singleProject } = useGetSingleProjectQuery(task.DProjectID);

  let [shareLead, { isLoading: leadShareLoading }] = useShareLeadMutation()


  let staffId = null;
  let storedStaffId = localStorage.getItem("id");

  if (storedStaffId) {
    try {
      staffId = decryptData(storedStaffId);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }
  let role = null;
  let storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }
  // const { data: hierarchyStaff } = useGetSingleHierarchyQuery({ staffId });

  const { data: hierarchyStaff } = useGetActiveStaffQuery()
  const options = useMemo(() => {
    let options = [];
    hierarchyStaff?.map((staff) =>
      options.push({
        id: staff?._id,
        label: staff?.firstName + " " + staff?.lastName,
      })
    );

    return options;
  }, [hierarchyStaff]);

  const [trigger, { data: inventory }] = useLazyGetInventoryByProjectIdQuery();

  useEffect(() => {
    if (singleProject) {
      setloading(false);
    }
  }, [singleProject]);

  useEffect(() => {
    if (task?.DProjectID) {
      setSelectedProject(task.DProjectID);
    }
  }, [task]);

  useEffect(() => {
    if (task.DProjectID || task.DTprojectBlockName) {
      let project = task.DProjectID;
      let block = task.DTprojectBlockName;
      trigger({ project, block });
    }
  }, [task.DProjectID, task.DTprojectBlockName, trigger]);

  let inventoryData = [];
  inventory?.forEach((inven) => {
    if (inven.status === "Available") {
      inventoryData.push({
        unitNo: inven.unitNo,
        id: inven._id,
      });
    }
  });

  useEffect(() => {
    if (task.totalAmount && task.currentSubTypeTask) {
      let calculatedAmount = 0;

      switch (task.currentSubTypeTask) {
        case 'TP':
          calculatedAmount = task.totalAmount * 0.1;
          break;
        case 'PDP':
          calculatedAmount = task.totalAmount * 0.25;
          break;
        case 'DP':
          calculatedAmount = task.totalAmount * 0.25;
          break;
        default:
          calculatedAmount = 0;
      }

      const roundedAmount = parseFloat(calculatedAmount.toFixed(2));

      settask((prevTask) => ({
        ...prevTask,
        ammount: roundedAmount,
      }));
    }
  }, [task.totalAmount, task.currentSubTypeTask]);

  const handleProject = (e) => {
    let { name, value } = e.target;
    setloading(true);
    settask({ ...task, DTprojectBlockName: "", [name]: value });
  };

  // let handleChange = (e) => {
  //   let { name, value } = e.target;
  //   if (name === "nextTaskType") {
  //     setdoNothing(false);
  //     if (value === "doNothing") {
  //       setdoNothing(true);
  //     }
  //   }
  //   settask({ ...task, [name]: value });
  // };

  let handleChange = (e, closed) => {
    let { name, value } = e.target;

    if (name === "nextTaskType") {
      setdoNothing(value === "doNothing");
    }

    if (name === "paymentMode" && value !== "bank") {
      settask({ ...task, [name]: value, bankName: "" });
    } else if (closed === "closed") {
      settask({
        ...task, nextTaskType:
          "doNothing", [name]: value
      });

    }
    else {
      settask({
        ...task, nextTaskType:
          task.nextTaskType, [name]: value
      });
    }

  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    settask((prevstate) => ({
      ...prevstate,
      [name]: e.target.files[0],
    }));
    e.target.value = '';
  };

  const handleType = (e) => {
    const { value } = e.target;
    if (value === "Call") {
      setsubType([
        "SMS",
        "Call connected",
        "Call Not Connected",
        "Whatsapp",
        "Followed Up",
      ]);
      setclosedLost(false);
      setdoNothing(false);

    } else if (value === "Meeting") {
      setsubType([
        "Vedio Meeting",
        "Head Office Meeting",
        "Outdoor",
        "Site",
        "Walk In",
      ]);
      setdoNothing(false);

      setclosedLost(false);
    } else if (value === "Sales") {
      let filteredSubType = ["TP", "PDP", "DP", "closed-won"];

      if (task?.leadStatus === "TP") {
        filteredSubType = filteredSubType.filter((type) => type !== "TP");
      } else if (task?.leadStatus === "PDP") {
        filteredSubType = filteredSubType.filter(
          (type) => type !== "TP"
        );
      } else if (task?.leadStatus === "DP") {
        filteredSubType = filteredSubType.filter(
          (type) => type !== "TP" && type !== "PDP" && type !== "DP"
        );
      }
      setsubType(filteredSubType);
      setclosedLost(false);
      setdoNothing(false);

    } else if (value === "closed-lost") {
      settask((prevTask) => ({
        ...prevTask,
        nextTaskType: "doNothing",
      }));
      setsubType(["Nothing"]);
      setdoNothing(true);
      setclosedLost(true);
    }
    handleChange(e, value === "closed-lost" ? "closed" : null);
  };

  const handleSubtype = (e) => {
    settokenDownPayment(false);
    if (
      e.target.value === "TP" ||
      e.target.value === "DP" ||
      e.target.value === "PDP"
    ) {
      settokenDownPayment(true);
    }
    handleChange(e);
  };

  const handleLeadShare = () => {
    let body =
    {
      leadID: leadId,
      sharingEmployee: leadShareData.sharingEmployee.id,
      percentage: leadShareData.percentage
    }

    shareLead(body).unwrap()
      .then((res) => {
        toast.success("lead Shared successfully!")
      })
      .catch((err) => {
        toast.error(err?.data?.error?.message || "Error sharing Lead")
      })
      .finally(() => {
        setleadShareData({
          sharingEmployee: { label: "", id: "" },
          percentage: ""
        })
      })
  }
  const handleSave = () => {
    var formdata = new FormData();
    const completedDate = moment(task.completedDate).utc().format('YYYY-MM-DDTHH:mm:ss');

    formdata.append("currentTaskType", task.currentTaskType);
    formdata.append("currentSubTypeTask", task.currentSubTypeTask);
    formdata.append("completedDate", completedDate);
    formdata.append("reason", task.reason);
    formdata.append("comment", task.comment);
    formdata.append("nextTaskType", task.nextTaskType);
    formdata.append("deadline", task.deadline);
    formdata.append("attachment", task.attachment);
    formdata.append("idCardFrontPicture", task.cnicfront);
    formdata.append("idCardBackPicture", task.cnicback);
    formdata.append("cnic", task.cnic);
    formdata.append("address", task.address);
    formdata.append("personalPicture", task.personalimage);
    formdata.append("country", task.nationality);
    formdata.append("phoneNo", task.phoneNo);
    formdata.append("developerName", task.developername);
    formdata.append("projectID", task.DProjectID);
    formdata.append("DTprojectBlockName", task.DTprojectBlockName);
    formdata.append("unitNumber", task.invenID);
    formdata.append("amount", task.ammount);
    formdata.append("paymentMode", task.paymentMode);
    formdata.append("paymentType", task.currentSubTypeTask);
    formdata.append("bankName", task.bankName);
    formdata.append("totalAmount", task.totalAmount);
    formdata.append("transactionId", task.transactionNo);
    // formdata.append("depositeDate", task.depositeDate);
    formdata.append("status", task.status);
    formdata.append("paymentproof", task.approvedPayment);
    formdata.append("clientID", task.clientId)
    let id = task.leadId;
    addTask({ formdata, id })
      .unwrap()
      .then((res) => {
        toast.success("task created successfully");
        settask({
          currentTaskType: "",
          currentSubTypeTask: "",
          completedDate: defaultDate,
          reason: "",
          comment: "",
          nextTaskType: "",
          deadline: "",
          DProjectID: "",
          DTprojectBlockName: "",
          invenID: "",
          address: "",
          nationality: "",
          cnic: "",
          developername: "",
          ammount: "",
          paymentMode: "",
          bankName: "",
          transactionNo: "",
          // depositeDate: "",
          status: "",
          attachment: "",
          cnicback: "",
          cnicfront: "",

          approvedPayment: "",
          leadId: task.leadId,
        });
        setpopUp(false);
      })
      .catch((error) => {
        toast.error(error?.data?.error?.message);
      });
  };

  const [favouriteLoading, setfavouriteLoading] = useState(false);

  // const { data: leads, isFetching } = useGetAllLeadsQuery();

  const [addFavourite] = useAddFavouriteMutation();

  const handleAddFavourite = (id) => {
    setfavouriteLoading(true);
    const body = {
      LeadID: id,
    };
    addFavourite(body)
      .unwrap()
      .then((res) => {
        toast.success("Added to favourite");
        setfavouriteLoading(false);
      })
      .catch((error) => {
        toast.error(error.data.message);
        setfavouriteLoading(false);
      });
  };

  useEffect(() => {
    if (taskPopUp || popUp || numberPopUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [taskPopUp, popUp, numberPopUp]);

  const columns = [
    {
      field: "client",
      headerName: "Client",
      width: 110,
      renderCell: (params) => {
        return (
          <Client>
            <Tooltip title={params.row.client}>
              <div>{params.row.client}</div>
            </Tooltip>
            <div>
              {params.row.favourite ? (
                <StarIcon
                  sx={{
                    color: `${colors.starYellow}`,
                    fontSize: `small`,
                    cursor: `pointer`,
                  }}
                />
              ) : (
                <StarBorderIcon
                  sx={{
                    color: `${colors.starYellow}`,
                    fontSize: `small`,
                    cursor: `pointer`,
                  }}
                  onClick={() => handleAddFavourite(params.row.id)}
                />
              )}
              <span>lead</span>
            </div>
          </Client>
        );
      },
    },
    // {
    //   field: "allocatedto",
    //   headerName: "Allocated To",
    //   width: 110,
    //   renderCell: (params) => {
    //     return (
    //       <Tooltip title={params.row.allocatedto}>
    //         <div>{params.row.allocatedto}</div>
    //         {/* <div>faisalabad</div> */}
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      field: "leadId",
      headerName: "Lead ID",
      width: 150,
      renderCell: (params) => {
        return params.row.classification === "veryHot" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.veryHot}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "hot" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.hot}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "moderate" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.moderate}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "cold" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.cold}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.veryCold}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        );
      },
    },
    {
      field: "source",
      headerName: "Source",
      width: 150,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 150,
      valueGetter: (params) =>
        params.row.phone?.length > 0 ? params.row?.phone[0]?.phoneNo : "",
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.phone?.length > 1 ? (
              <button
                onClick={() => {
                  setphoneData(params.row.phone);
                  setnumberPopUp(true);
                }}
                style={{
                  width: "100%",
                  backgroundColor: `${colors.brown}`,
                  color: `${colors.white}`,
                  padding: "0.5em 0em",
                  cursor: "pointer",
                  borderRadius: "5px",
                  border: `1px solid ${colors.inputBorderWhite}`,
                }}
              >
                {params.row?.phone[0]?.phoneNo}
              </button>
            ) : (
              <a href={`tel:+${params.row?.phone[0]?.phoneNo}`}>{params.row?.phone[0]?.phoneNo}</a>
            )}
          </div>
        );
      },
    },

    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 150,
    //   renderCell: (params) => {
    //     return params.row.status === "contracted" ? (
    //       <Contracted color={"#66cb66d6"}>
    //         <div>{params.row.status}</div>
    //       </Contracted>
    //     ) : params.row.status === "E-mail" ? (
    //       <Contracted color={"#6767f4"}>
    //         <div>{params.row.status}</div>
    //       </Contracted>
    //     ) : (
    //       <Contracted color={"#f85a5a"}>
    //         <div>{params.row.status}</div>
    //       </Contracted>
    //     );
    //   },
    // },
    {
      field: "project",
      headerName: "Project",
      width: 110,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.project}>
            <div style={{ color: `${colors.textBlue}` }}>
              {params.row.project}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "daysInactive",
      headerName: "Days Inactive",
      width: 120,
      renderCell: (params) => {
        const days = params.row.daysInactive;
        let color = "#10b981"; // Green for recent
        let bgColor = "#ecfdf5";

        if (days === null || days === undefined) {
          return (
            <div style={{
              padding: "8px 12px",
              fontSize: "0.8rem",
              fontWeight: 600,
              color: "#6b7280",
              background: "#f3f4f6",
              borderRadius: "6px",
              textAlign: "center",
              border: "1px solid #e5e7eb"
            }}>
              No tasks
            </div>
          );
        }

        if (days > 60) {
          color = "#dc2626"; // Red for very inactive
          bgColor = "#fef2f2";
        } else if (days > 30) {
          color = "#ea580c"; // Orange for inactive
          bgColor = "#fff7ed";
        } else if (days > 7) {
          color = "#d97706"; // Yellow for moderately inactive
          bgColor = "#fffbeb";
        }

        return (
          <Tooltip title={`Last task was ${days} days ago`}>
            <div style={{
              padding: "8px 12px",
              fontSize: "0.8rem",
              fontWeight: 600,
              color: color,
              background: bgColor,
              borderRadius: "6px",
              textAlign: "center",
              border: `1px solid ${color}20`,
              cursor: "help"
            }}>
              {days} days
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      width: 180,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => {
        let whatsappLink = `https://wa.me/` + params.row.cellNo;
        let mailLink = `mailto:` + params.row.mail;
        return (
          <Action>
            <div
              onClick={() => {
                settask({
                  ...task, leadId: params.row.id,
                  clientId: params.row.clientId,
                  clientname: params.row.client,
                  phoneNo: params.row.cellNo,
                  projectName: params.row.project,
                  DProjectID: params.row.projectId,
                  leadStatus: params.row.leadstatus

                });
                setpopUp(true);
              }}
            >
              <img src="/assets/icons/plus.png" alt="plus" />
            </div>
            <a
              href={whatsappLink}
              onClick="location.href=this.href+'?key='+number;return false;"
              target="_blank"
              rel="noreferrer"
            >
              <WhatsAppIcon style={{ color: "green", cursor: "pointer" }} />
            </a>
            {/* <a href={mailLink} target="_blank" rel="noreferrer">
              <MailOutlineIcon
                style={{ color: "#1194D1", cursor: "pointer" }}
              />
            </a> */}
            {role !== "ts" && (
              <>
                <ShareIcon
                  style={{ color: "#EC2643", cursor: "pointer" }}
                  onClick={() => {
                    setleadSharePopUp(true);
                    setleadId(params.row.id);
                  }}
                />
              </>
            )}
            <RemoveRedEyeIcon
              style={{ color: `${colors.brown}`, cursor: "pointer" }}
              onClick={() => {
                setTaskPopUp(true);
                setleadId(params.row.id);
                setLeadNumber(params.row.leadId);
              }}
            />
          </Action>
        );
      },
    },
  ];
  let rows = [];
  // Handle both regular leads format (leads.leads) and optimized telesales format (leads directly)
  const leadsArray = leads?.leads || leads || [];

  // Debug logs removed for production cleanliness

  leadsArray.forEach((lead, index) => {
    try {
    // Calculate days since last task
    let daysInactive = null;
    if (lead?.lastTaskDate) {
      const lastTaskDate = new Date(lead.lastTaskDate);
      const today = new Date();
      const diffTime = Math.abs(today - lastTaskDate);
      daysInactive = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

      // Handle different data structures for telesales vs regular leads
      const clientData = lead?.clientID || lead?.client;
      const employeeData = lead?.employeeID || lead?.employee;
      const projectData = lead?.leadOpportunity?.project || lead?.project;

      // Safe phone number extraction
      let phoneNumber = "N/A";
      if (clientData?.cellNo) {
        if (Array.isArray(clientData.cellNo) && clientData.cellNo.length > 0) {
          phoneNumber = clientData.cellNo[0]?.phoneNo || "N/A";
        } else if (typeof clientData.cellNo === 'object' && clientData.cellNo.phoneNo) {
          phoneNumber = clientData.cellNo.phoneNo;
        } else if (typeof clientData.cellNo === 'string') {
          phoneNumber = clientData.cellNo;
        }
      }

      // project data available via projectData

    rows.push({
        client: clientData?.fullName || "N/A",
        allocatedto: employeeData?.firstName
          ? `${employeeData.firstName} ${employeeData.lastName || ''}`.trim()
          : employeeData?.firstName || "N/A",
        leadId: lead?.leadID || "N/A",
        source: lead?.leadOpportunity?.source || "N/A",
        project: projectData?.projectName || projectData?.name || "N/A",
        projectId: projectData?._id || "N/A",
        classification: lead?.leadOpportunity?.classification || "N/A",
        favourite: lead?.favourite || false,
        id: lead._id || "N/A",
        leadstatus: lead?.leadStatus || "active",
        clientId: clientData?._id || "N/A",
        cellNo: phoneNumber,
        mail: clientData?.email || "N/A",
        phone: clientData?.cellNo || [],
        feedback: lead?.feedback || "N/A",
        badge: !lead?.taskExists || false,
        daysInactive: daysInactive || 0
      });
    } catch (error) {
      console.error(`Error processing lead at index ${index}:`, error, lead);
      // Add a fallback row for problematic data
      rows.push({
        client: "Error",
        allocatedto: "Error",
        leadId: "N/A",
        source: "N/A",
        project: "N/A",
        projectId: "N/A",
        classification: "N/A",
        favourite: false,
        id: lead?._id || `error-${index}`,
        leadstatus: "error",
        clientId: "N/A",
        cellNo: "N/A",
        mail: "N/A",
        phone: [],
        feedback: "N/A",
        badge: false,
        daysInactive: 0
      });
    }
  });

  // rows processed count available if needed

  return (
    <Main>
      <LeadsSection>
        <div className="lead-count">
          Total Leads: <span>{leads?.total}</span>
        </div>
        <div className="new-leads-indicator">
          <div className="blink-dot"></div>
          <span>Live Data</span>
        </div>
      </LeadsSection>
      <Table>
        {rows.length > 0 ? (
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(0);
          }}
          rowsPerPageOptions={[20, 50, 100]}
          checkboxSelection
          disableSelectionOnClick
          loading={isFetching}
          pagination
          paginationMode="server"

          onPageChange={(newPage) => {
            setPage(newPage);
          }}
            loadingOverlay={isFetching ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '200px',
                gap: '1.5rem',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.95) 100%)',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{
                  position: 'relative',
                  width: '50px',
                  height: '50px'
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    border: '4px solid rgba(36, 147, 147, 0.1)',
                    borderTop: '4px solid #249393',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    width: '34px',
                    height: '34px',
                    border: '2px solid rgba(36, 147, 147, 0.2)',
                    borderTop: '2px solid #1a6b6b',
                    borderRadius: '50%',
                    animation: 'spin 1.5s linear infinite reverse'
                  }} />
                </div>
                <div style={{
                  textAlign: 'center',
                  color: '#249393',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  <div style={{ marginBottom: '0.5rem' }}>
                    {isFetching ? 'Searching leads...' : 'Loading leads...'}
                  </div>
                  <div style={{
                    fontSize: '0.85rem',
                    color: '#64748b',
                    fontWeight: '400'
                  }}>
                    Please wait while we fetch your data
                  </div>
                </div>
              </div>
            ) : undefined}
            rowCount={leads?.total || 0}
          autoHeight
          sx={{
              border: "1px solid #e0e0e0",
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' }
              },
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #f0f0f0',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #e0e0e0',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f8f9fa',
              },
            }}
          />
        ) : (
          <EmptyState>
            <div className="empty-icon">📊</div>
            <h3>No Leads Found</h3>
            <p>
              {isFetching
                ? "Loading leads..."
                : "No leads match your current search criteria. Try adjusting your filters or search again."
              }
            </p>
          </EmptyState>
        )}
        {favouriteLoading ? <Loader /> : null}
      </Table>
      {/* <PopUpContainer  popUp={popUp}>
        <PopUp>
          <Cross onClick={() => setpopUp(!popUp)}>
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <PopUpSection>
            <TaskTable leadId={leadId} />
          </PopUpSection>
        </PopUp>
      </PopUpContainer> */}

      {popUp && createPortal(
        <PortalPopUpContainer>
        <PopUp>
          <Cross
            onClick={() => {
              settask({
                currentTaskType: "",
                currentSubTypeTask: "",
                completedDate: defaultDate,
                subType: "",
                reason: "",
                comment: "",
                nextTaskType: "",
                developername: "",
                deadline: "",
                DProjectID: "",
                cnic: "",
                nationality: "",
                address: "",
                cnicfront: "",
                cnicback: "",
                personalimage: "",
                DTprojectBlockName: "",
                invenID: "",
                ammount: 0,
                paymentMode: "",
                bankName: "",
                transactionNo: 0,
                totalAmount: 0,
                leadStatus: "",
                status: "",
                attachment: "",
                approvedPayment: "",
                leadId: task.leadId,
              });
              setpopUp(false);
            }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <PopUpSection>
            <Section>
              <Task>
                  <Heading>Current Task</Heading>
                <InputPart>
                  <InputFeild>
                    <h3>Type:<b style={{ color: "red" }}>*</b></h3>
                    <div>
                      <select
                        name="currentTaskType"
                        id="currentTaskType"
                        value={task.currentTaskType}
                        onChange={handleType}
                      >
                        {role === "ts" ? (
                          <>
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Call">Call</option>
                          </>
                        ) : (
                          <>
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Call">Call</option>
                            <option value="Meeting">Meeting</option>
                            <option value="Sales">Sales</option>
                            <option value="closed-lost">Closed (Lost)</option>
                          </>
                        )}
                      </select>
                    </div>
                  </InputFeild>
                  <InputFeild>
                    <h3>Sub-Type:<b style={{ color: "red" }}>*</b></h3>
                    <div>
                      <select
                        name="currentSubTypeTask"
                        id="currentSubTypeTask"
                        value={task.currentSubTypeTask}
                        onChange={handleSubtype}
                      >
                        <option value=""  >Select</option>
                        {subType?.map((ls) => (
                          <option value={ls} key={ls}>
                            {ls}
                          </option>
                        ))}
                      </select>
                    </div>
                  </InputFeild>
                  <InputFeild>
                    <h3>Completed Date:<b style={{ color: "red" }}>*</b></h3>
                    <div>
                      <input
                        type="datetime-local"
                        name="completedDate"
                        id="completedDate"
                        value={task.completedDate || defaultDate}
                        onChange={handleChange}
                        min={newMinDate}
                        max={defaultDate}
                      />
                    </div>
                  </InputFeild>
                  {closedLost ? (
                    <InputFeild>
                      <h3>Reason:<b style={{ color: "red" }}>*</b></h3>
                      <input
                        type="text"
                        name="reason"
                        id="reason"
                        placeholder="Type Here..."
                        value={task.reason}
                        onChange={handleChange}
                      />
                    </InputFeild>
                  ) : null}
                  {tokenDownPayment === false ? (
                    <>
                      <InputFeild>
                        <h3>Comment:<b style={{ color: "red" }}>*</b></h3>
                        <textarea
                          name="comment"
                          id="comment"
                          placeholder="type here..."
                          value={task.comment}
                          onChange={handleChange}
                        ></textarea>
                      </InputFeild>
                      {
                        task.currentTaskType === 'Meeting' || task.currentTaskType === "Sales" || task.currentSubTypeTask === "Whatsapp" ?
                          <InputFeild>
                            <h3>Attachment:<b style={{ color: "red" }}>*</b></h3>
                            <span>
                              <p>upload file here</p>
                              <label htmlFor="attachment">
                                <AttachFileIcon /> Upload
                              </label>
                              {task.attachment && (
                                <UploadedFile
                                  src={URL.createObjectURL(task.attachment)}
                                  alt="uploaded file"
                                />
                              )}
                            </span>
                            <input
                              type="file"
                              name="attachment"
                              id="attachment"
                              onChange={handleFileChange}
                            />
                          </InputFeild> : null}
                    </>
                  ) : null}
                  {tokenDownPayment ? (
                    <>
                      {/* <InputFeild>
                        <Headinginfo>Project Details</Headinginfo>
                      </InputFeild> */}

                      {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                        <>
                          <Heading>Project Details</Heading>
                          <InputFeild>
                            <h3>
                              Project:<b style={{ color: "red" }}>*</b>
                            </h3>
                            <div>
                              <select
                                name="DProjectID"
                                id="DProjectID"
                                disabled
                                value={selectedProject}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setSelectedProject(value);
                                  settask((prevTask) => ({
                                    ...prevTask,
                                    DProjectID: value,
                                  }));
                                }}
                              >
                                <option value="">Select Project</option>
                                {project?.map((pro) => (
                                  <option key={pro._id} value={pro._id}>
                                    {pro.projectName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </InputFeild>
                        </>
                      )}

                      {loading ? (
                        <TaskLoader>
                          <Puff
                            height="40"
                            width="40"
                            radius={1}
                            color={colors.brown}
                            ariaLabel="puff-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                          />
                        </TaskLoader>
                      ) : null}
                      {singleProject?.projectBlock?.length > 0 ? (
                        <InputFeild>
                          <h3>Project Block:</h3>
                          <div>
                            <select
                              name="DTprojectBlockName"
                              id="DTprojectBlockName"
                              onChange={handleChange}
                            >
                              <option value="">select</option>
                              {singleProject?.projectBlock?.map((pro) => (
                                <option value={pro.blockName}>
                                  {pro.blockName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </InputFeild>
                      ) : null}
                      {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                        <InputFeild>
                          <h3>Unit: <b style={{ color: "red" }}>*</b></h3>
                          <div>
                            {/* <select
                            name="invenID"
                            id="invenID"
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {inventoryData?.map((inven) => (
                              <option value={inven.id}>{inven.unitNo}</option>
                            ))}
                          </select> */}
                            <input
                              type="text"
                              name="invenID"
                              id="invenID"
                              value={task.invenID}
                              onChange={handleChange}
                            />
                          </div>
                        </InputFeild>
                      )}
                      {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                        <InputFeild>
                          <h3>Developer Name:<b style={{ color: "red" }}>*</b></h3>
                          <div>
                            <input
                              type="text"
                              name="developername"
                              id="developername"
                              value={task.developername}
                              onChange={handleChange}
                            />
                          </div>
                        </InputFeild>
                      )}
                      {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                        <InputFeild>
                          <h3>Total Amount:<b style={{ color: "red" }}>*</b></h3>
                          <div>
                            <input
                              type="number"
                              name="totalAmount"
                              id="totalAmount"
                              value={task.totalAmount}
                              onChange={handleChange}
                            />
                          </div>
                        </InputFeild>
                      )}
                      {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                        <>
                          <Heading>Client Details</Heading>
                          <InputFeild>
                            <h3>
                              Client Name: <b style={{ color: "red" }}>*</b>
                            </h3>
                            <input
                              type="text"
                              name="clientname"
                              id="clientname"
                              disabled
                              value={task.clientname || ''}
                              onChange={handleChange}
                            />
                          </InputFeild>
                          <InputFeild>
                            <h3>
                              Phone: <b style={{ color: "red" }}>*</b>
                            </h3>
                            <input
                              type="number"
                              name="phone"
                              id="phone"
                              disabled
                              value={task.phoneNo}
                              onChange={handleChange}
                            />
                          </InputFeild>
                          <InputFeild>
                            <h3>
                              CNIC: <b style={{ color: "red" }}>*</b>
                            </h3>
                            <input
                              type="number"
                              name="cnic"
                              id="cnic"
                              value={task.cnic}
                              onChange={handleChange}
                            />
                          </InputFeild>
                          <InputFeild>
                            <h3>
                              Nationality: <b style={{ color: "red" }}>*</b>
                            </h3>
                            <input
                              type="text"
                              name="nationality"
                              id="nationality"
                              value={task.nationality}
                              onChange={handleChange}
                            />
                          </InputFeild>
                          <InputFeild>
                            <h3>
                              Address: <b style={{ color: "red" }}>*</b>
                            </h3>
                            <textarea
                              name="address"
                              id="address"
                              placeholder="type here..."
                              value={task.address}
                              onChange={handleChange}
                            ></textarea>
                          </InputFeild>
                        </>
                      )}

                      <Heading>Add Payment</Heading>
                      <InputFeild>
                        <h3>Payment Mode: <b style={{ color: "red" }}>*</b></h3>
                        <div>
                          <select
                            name="paymentMode"
                            id="paymentMode"
                            onChange={handleChange}
                            value={task.paymentMode}
                          >
                            <option value="">Select</option>
                            <option value="online">Online</option>
                            <option value="cheque">Cheque</option>
                            <option value="cash">Cash</option>
                            <option value="bank">Bank Transfer</option>
                          </select>
                        </div>
                      </InputFeild>
                      {task.paymentMode === "bank" && (
                        <BankInputFeild>
                          <h3>
                            Bank Name: <b style={{ color: "red" }}>*</b>
                          </h3>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={Banks}
                            value={task.bankName}
                            onChange={(event, newValue) =>
                              settask({ ...task, bankName: newValue })
                            }
                            sx={{
                              width: "100%",
                              border: `1px solid ${colors.inputBorderWhite}`,
                              borderRadius: "5px",
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                sx={{ backgroundColor: `${colors.inputWhite}` }}
                              />
                            )}
                          />
                        </BankInputFeild>
                      )}
                      <InputFeild>
                        <h3>Amount:<b style={{ color: "red" }}>*</b></h3>
                        <input
                          type="number"
                          name="ammount"
                          id="ammount"
                          value={task.ammount}
                          onChange={handleChange}
                        />
                      </InputFeild>
                      <InputFeild>
                        <h3>Transaction No:<b style={{ color: "red" }}>*</b></h3>
                        <input
                          type="number"
                          name="transactionNo"
                          id="transactionNo"
                          value={task.transactionNo}
                          onChange={handleChange}
                        />
                      </InputFeild>

                      {/* <InputFeild>
                        <h3>Deposite Date:<b style={{ color: "red" }}>*</b></h3>
                        <div>
                          <input
                            type="date"
                            name="depositeDate"
                            id="depositeDate"
                            value={task.depositeDate}
                            onChange={handleChange}
                          />
                        </div>
                      </InputFeild> */}
                      {task.currentSubTypeTask === "DP" && (
                        <InputFeild>
                          <h3>Personal Image:<b style={{ color: "red" }}>*</b></h3>
                          <span>
                            <p>upload file here</p>
                            <label htmlFor="personalimage">
                              <AttachFileIcon /> Upload
                            </label>
                            {task.personalimage && (
                              <UploadedFile
                                src={URL.createObjectURL(task.personalimage)}
                                alt="uploaded file"
                              />
                            )}
                          </span>
                          <input
                            type="file"
                            name="personalimage"
                            id="personalimage"
                            onChange={handleFileChange}
                          />
                        </InputFeild>
                      )}
                      {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                        <>
                          <InputFeild>
                            <h3>CNIC Front:<b style={{ color: "red" }}>*</b></h3>
                            <span>
                              <p>upload file here</p>
                              <label htmlFor="cnicfront">
                                <AttachFileIcon /> Upload
                              </label>
                              {task.cnicfront && (
                                <UploadedFile
                                  src={URL.createObjectURL(task.cnicfront)}
                                  alt="uploaded file"
                                />
                              )}
                            </span>
                            <input
                              type="file"
                              name="cnicfront"
                              id="cnicfront"
                              onChange={handleFileChange}
                            />
                          </InputFeild>
                          <InputFeild>
                            <h3>CNIC Back:<b style={{ color: "red" }}>*</b></h3>
                            <span>
                              <p>upload file here</p>
                              <label htmlFor="cnicback">
                                <AttachFileIcon /> Upload
                              </label>
                              {task.cnicback && (
                                <UploadedFile
                                  src={URL.createObjectURL(task.cnicback)}
                                  alt="uploaded file"
                                />
                              )}
                            </span>
                            <input
                              type="file"
                              name="cnicback"
                              id="cnicback"
                              onChange={handleFileChange}
                            />
                          </InputFeild>
                        </>
                      )}
                      <InputFeild>
                        <h3>Attach Payment Proof:<b style={{ color: "red" }}>*</b></h3>
                        <span>
                          <p>upload file here</p>
                          <label htmlFor="approvedPayment">
                            <AttachFileIcon /> Upload
                          </label>
                          {task.approvedPayment && (
                            <UploadedFile
                              src={URL.createObjectURL(task.approvedPayment)}
                              alt="uploaded file"
                            />
                          )}
                        </span>
                        <input
                          type="file"
                          name="approvedPayment"
                          id="approvedPayment"
                          onChange={handleFileChange}
                        />
                        <p>
                          Note: Invalid payment proof will result in
                          cancellation of payment and inventory will released
                          immediately.
                        </p>
                      </InputFeild>
                      <InputFeild>
                        <h3>Comment:<b style={{ color: "red" }}>*</b></h3>
                        <textarea
                          name="comment"
                          id="comment"
                          placeholder="type here..."
                          value={task.comment}
                          onChange={handleChange}
                        ></textarea>
                      </InputFeild>
                      {/* <FixedContainer>
                        <Price>
                          <h4>Unit Price:</h4>
                          <p>PKR 1230000</p>
                        </Price>
                        <InputFeild>
                          <h3>Unit Status:</h3>
                          <div>
                            <select
                              name="status"
                              id="status"
                              value={task.status}
                              onChange={handleChange}
                            >
                              <option value="downPayment" disabled>
                                downPayment
                              </option>
                            </select>
                          </div>
                        </InputFeild>
                        <InputFeild>
                          <h3>Unit Discount</h3>
                          <input
                            type="text"
                            value={"0"}
                            name="uniDiscount"
                            id="unitDiscount"
                            disabled
                          />
                        </InputFeild>
                        <InputFeild>
                          <h3>Deal Price</h3>
                          <input
                            type="text"
                            value={"342324"}
                            name="dealPrice"
                            id="dealPrice"
                            disabled
                          />
                        </InputFeild>
                        <Price>
                          <h4>Due Amount:</h4>
                          <p>PKR 1230000</p>
                        </Price>
                      </FixedContainer> */}
                    </>
                  ) : null}
                </InputPart>
              </Task>
                {/* <ButtonPart>
                <button
                  onClick={() => {
                    settask({
                      currentTaskType: "",
                      leadStatus: "",
                      currentSubTypeTask: "",
                      completedDate: defaultDate,
                      subType: "",
                      reason: "",
                      comment: "",
                      nextTaskType: "",
                      developername: "",
                      deadline: "",
                      DProjectID: "",
                      cnic: "",
                      nationality: "",
                      address: "",
                      cnicfront: "",
                      cnicback: "",
                      personalimage: "",
                      DTprojectBlockName: "",
                      invenID: "",
                      ammount: 0,
                      paymentMode: "",
                      bankName: "",
                      transactionNo: 0,
                      totalAmount: 0,
                      leadStatus: "",
                      status: "",
                      attachment: "",
                      approvedPayment: "",
                      leadId: task.leadId,
                    });
                    setpopUp(false);
                  }}
                >
                  Cancel
                </button>
                </ButtonPart> */}
            </Section>
            <Section>
              <Task style={{ borderRight: "none" }}>
                  <Heading>Next Task</Heading>
                <InputPart>
                  <InputFeild>
                    <h3>Next Task:<b style={{ color: "red" }}>*</b></h3>
                    <div>
                      <select
                        name="nextTaskType"
                        id="nextTaskType"
                        value={task.nextTaskType || ""}
                        onChange={handleChange}
                      >
                        {role === "ts" ? (
                          <>
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="meetClient">Meet Client</option>
                            <option value="Meeting">Meeting</option>
                            <option value="rescheduleMeeting">Reschedule Meeting</option>
                          </>
                        ) : (
                          <>
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="doNothing">Do Nothing</option>
                            <option value="followUp">Follow Up</option>
                            <option value="contractedClient">Contracted Client</option>
                            <option value="closed-won">Close Won</option>
                            <option value="meetClient">Meet Client</option>
                            <option value="recievePartialDownPayment">Receive Partial Down Payment</option>
                            <option value="recieveCompleteDownPayment">Receive Complete Down Payment</option>
                            <option value="arrangeMeeting">Arrange Meeting</option>
                            <option value="receivetokenPayment">Receive Token Payment</option>
                          </>
                        )}
                      </select>
                    </div>
                  </InputFeild>

                  {doNothing === false ? (
                    <InputFeild>
                      <h3>Deadline:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        <input
                          type="datetime-local"
                          name="deadline"
                          id="deadline"
                          value={task.deadline}
                          onChange={handleChange}
                          min={new Date().toISOString().slice(0, 16)}
                        />
                      </div>
                    </InputFeild>
                  ) : null}
                </InputPart>
              </Task>
                {/* <ButtonPart>
                <button
                  style={{
                    backgroundColor: `${colors.textBlue}`,
                    color: `${colors.white}`,
                    opacity: isLoading ? "0.5" : "1",
                  }}
                  onClick={handleSave}
                  disabled={isLoading}
                >
                  {isLoading ? <>Saving...</> : <>Save</>}
                </button>
                </ButtonPart> */}
            </Section>
          </PopUpSection>
            <ButtonPart>
              <button
                className="cancel-btn"
                onClick={() => {
                  settask({
                    currentTaskType: "",
                    leadStatus: "",
                    currentSubTypeTask: "",
                    completedDate: defaultDate,
                    subType: "",
                    reason: "",
                    comment: "",
                    nextTaskType: "",
                    developername: "",
                    deadline: "",
                    DProjectID: "",
                    cnic: "",
                    nationality: "",
                    address: "",
                    cnicfront: "",
                    cnicback: "",
                    personalimage: "",
                    DTprojectBlockName: "",
                    invenID: "",
                    ammount: 0,
                    paymentMode: "",
                    bankName: "",
                    transactionNo: 0,
                    totalAmount: 0,
                    leadStatus: "",
                    status: "",
                    attachment: "",
                    approvedPayment: "",
                    leadId: task.leadId,
                  });
                  setpopUp(false);
                }}
              >
                Cancel
              </button>
              <button
                className="save-btn"
                style={{
                  opacity: isLoading ? "0.5" : "1",
                }}
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? <>Saving...</> : <>Save</>}
              </button>
            </ButtonPart>
        </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}
      {/* <PopUpContainer popUp={taskPopUp}>
        <PopUp>
          <Crosstask
            onClick={() => setTaskPopUp(!taskPopUp)}
            style={{ height: "3%" }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Crosstask>
          <PopUpSection style={{ height: "90%" }}>
            <TaskTable leadId={leadId} />
          </PopUpSection>
        </PopUp>
      </PopUpContainer> */}

      {taskPopUp && createPortal(
        <PortalPopUpContainer>
          <PopUp>
            <Crosstask
              onClick={() => setTaskPopUp(!taskPopUp)}
            >
              <img src="/assets/icons/cross.png" alt="cross" />
            </Crosstask>
            <PopUpSection className="task-table-section" style={{ height: "calc(100% - 80px)" }}>
              <TaskTable leadId={leadId} />
              {/* <UnifiedTaskTable leadID={leadId} leadNumber={leadNumber} /> */}
            </PopUpSection>
          </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}

      <PopUpContainer popUp={numberPopUp}>
        <NumberPopUp>
          <Cross
            onClick={() => setnumberPopUp(!numberPopUp)}
            style={{ height: "5%" }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <NumberPopUpSection style={{ height: "90%" }}>
            {phoneData.map((phone) => (
              <div>+{phone?.phoneNo}</div>
            ))}
          </NumberPopUpSection>
        </NumberPopUp>
      </PopUpContainer>
      <PopUpContainer popUp={leadSharePopUp}>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <AssignLeadModal key={`share-modal-${Date.now()}`}>
          <Cross
            onClick={() => {
              setleadSharePopUp(!leadSharePopUp);
              setleadShareData({ ...leadShareData, sharingEmployee: null });
            }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>

          {/* Professional Header */}
          <div style={{
            padding: '2rem 2rem 1rem 2rem',
            borderBottom: '1px solid #f0f0f0',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: '16px 16px 0 0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: `linear-gradient(135deg, #EC2643 0%, #c41e3a 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(236, 38, 67, 0.3)'
              }}>
                <ShareIcon style={{ color: 'white', fontSize: '24px' }} />
              </div>
              <div>
                <h2 style={{
                  margin: 0,
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  letterSpacing: '-0.025em'
                }}>
                  Share Lead
                </h2>
                <p style={{
                  margin: '0.25rem 0 0 0',
                  fontSize: '0.95rem',
                  color: '#6b7280',
                  fontWeight: '500'
                }}>
                  Share this lead with another team member
                </p>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div style={{
            padding: '2rem',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem'
          }}>
            {/* Staff Selection */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <label style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem'
              }}>
                Select Staff Member
              </label>
              <Autocomplete
                id="share-staff-autocomplete"
                size="small"
                options={options}
                getOptionLabel={(option) => option.label}
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
                onChange={(e, value) => {
                  setleadShareData({ ...leadShareData, sharingEmployee: value })
                }}
                value={leadShareData.sharingEmployee}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Choose a staff member..."
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: '#ffffff',
                        border: '2px solid #e5e7eb',
                        '&:hover': {
                          borderColor: '#d1d5db',
                        },
                        '&.Mui-focused': {
                          borderColor: '#EC2643',
                          boxShadow: '0 0 0 3px rgba(236, 38, 67, 0.1)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: '#6b7280',
                        fontWeight: '500',
                      },
                    }}
                  />
                )}
              />
            </div>

            {/* Percentage Input */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <label style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem'
              }}>
                Share Percentage
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type="number"
                  name="percentage"
                  id="percentage"
                  max={100}
                  min={0}
                  defaultValue={leadShareData.percentage}
                  onBlur={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue === '') {
                      setleadShareData({ ...leadShareData, percentage: '' });
                      return;
                    }
                    const numValue = parseFloat(inputValue);
                    if (!isNaN(numValue)) {
                      const clampedValue = Math.min(100, Math.max(0, numValue));
                      setleadShareData({ ...leadShareData, percentage: clampedValue.toString() });
                      e.target.value = clampedValue.toString();
                    }
                    // Reset styling
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                  placeholder="Enter percentage (0-100)"
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    fontSize: '1rem',
                    fontWeight: '500',
                    borderRadius: '12px',
                    border: '2px solid #e5e7eb',
                    backgroundColor: '#ffffff',
                    color: '#374151',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#EC2643';
                    e.target.style.boxShadow = '0 0 0 3px rgba(236, 38, 67, 0.1)';
                  }}
                />
                <span style={{
                  position: 'absolute',
                  right: '16px',
                  top: '50%',
                  color: '#6b7280',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  pointerEvents: 'none'
                }}>
                  %
                </span>
              </div>
            </div>
          </div>

          {/* Footer Section */}
          <div style={{
            padding: '1.5rem 2rem 2rem 2rem',
            borderTop: '1px solid #f0f0f0',
            background: '#fafafa'
          }}>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setleadSharePopUp(!leadSharePopUp);
                  setleadShareData({ ...leadShareData, sharingEmployee: null });
                }}
                style={{
                  padding: '12px 24px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  border: '2px solid #d1d5db',
                  background: '#ffffff',
                  color: '#6b7280',
                  cursor: 'pointer',
                  minWidth: '100px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#9ca3af';
                  e.target.style.color = '#374151';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.color = '#6b7280';
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleLeadShare}
                disabled={leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage}
                style={{
                  padding: '12px 24px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  border: 'none',
                  background: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? '#d1d5db'
                    : `linear-gradient(135deg, #EC2643 0%, #c41e3a 100%)`,
                  color: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? '#9ca3af'
                    : '#ffffff',
                  cursor: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? 'not-allowed'
                    : 'pointer',
                  minWidth: '120px',
                  boxShadow: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? 'none'
                    : '0 4px 12px rgba(236, 38, 67, 0.3)',
                  opacity: leadShareLoading ? '0.7' : '1'
                }}
              >
                {leadShareLoading ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid transparent',
                      borderTop: '2px solid currentColor',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                    Sharing...
                  </div>
                ) : (
                  'Share Lead'
                )}
              </button>
            </div>
          </div>
        </AssignLeadModal>
      </PopUpContainer>
      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: ${colors.white};
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;
const LeadsSection = styled.div`
  padding: 1.5rem 2rem;
  border-bottom: 1px solid ${colors.inputBorderWhite};
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  
  > div {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
  }
  
  .lead-count {
    font-size: 1.1rem;
    color: ${colors.text};
    font-weight: 600;
    
    span {
      color: ${colors.brown};
      font-weight: 700;
      font-size: 1.2rem;
    }
  }
  
  .new-leads-indicator {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: ${colors.textMed};
    
    .blink-dot {
      width: 8px;
      height: 8px;
      background-color: ${colors.brown};
      border-radius: 50%;
      animation: blink 1s infinite;
    }
  }
  
  @keyframes blink {
    0%, 50% { opacity: 1; }
    51%, 100% { opacity: 0.3; }
  }
`;

const Csvbutton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.textMed};
  background: ${colors.white};
  padding: 12px 16px;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  
  &:hover {
    border-color: ${colors.brown};
    color: ${colors.brown};
    background: ${colors.lightWhite};
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.15);
  }
  
  &:active {
  }
`

const Table = styled.div`
  padding: 1.5rem 2.5rem 2.5rem 2.5rem;
  
  .MuiDataGrid-root {
    border: none !important;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    background: ${colors.white};
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    }
  }
  
  .MuiDataGrid-main {
    border-radius: 16px;
  }
  
  .MuiDataGrid-columnHeaders {
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    border-bottom: 3px solid ${colors.inputBorderWhite};
    font-weight: 700;
    color: ${colors.text};
    min-height: 60px !important;
    
    .MuiDataGrid-columnHeaderTitle {
      font-weight: 700;
      font-size: 0.9rem;
      letter-spacing: 0.025em;
    }
  }
  
  .MuiDataGrid-columnHeader {
    font-size: 0.9rem;
    font-weight: 700;
    color: ${colors.text};
    padding: 0 16px;
  }
  
  .MuiDataGrid-row {
    border-bottom: 1px solid ${colors.inputBorderWhite};
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
    
    &.Mui-selected {
      background: linear-gradient(135deg, rgba(36, 147, 147, 0.1) 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      border-left: 4px solid ${colors.brown};
    }
    
    &:nth-of-type(even) {
      background: rgba(248, 249, 250, 0.5);
    }
  }
  
  .MuiDataGrid-cell {
    border: none !important;
    font-size: 0.85rem;
    color: ${colors.text};
    padding: 16px;
    display: flex;
    align-items: center;
    
    &:focus {
      outline: none;
    }
  }
  
  .MuiDataGrid-footerContainer {
    border-top: 2px solid ${colors.inputBorderWhite};
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    min-height: 70px;
    padding: 0 24px;
  }
  
  .MuiTablePagination-root {
    color: ${colors.textMed};
    font-weight: 500;
    
    .MuiTablePagination-selectLabel,
    .MuiTablePagination-displayedRows {
      font-weight: 600;
    color: ${colors.text};
    }
    
    .MuiTablePagination-select {
      border-radius: 8px;
      border: 1px solid ${colors.inputBorderWhite};
      padding: 4px 8px;
      
      &:hover {
        border-color: ${colors.brown};
      }
    }
  }
  
  .MuiCheckbox-root {
    color: ${colors.brown} !important;
    padding: 8px;
    
    &.Mui-checked {
      color: ${colors.brown} !important;
    }
    
    &:hover {
      background: rgba(36, 147, 147, 0.1);
      border-radius: 4px;
    }
  }
  
  // Custom scrollbar
  .MuiDataGrid-virtualScroller {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: ${colors.lightWhite};
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: ${colors.inputBorderWhite};
      border-radius: 4px;
      
      &:hover {
        background: ${colors.textMed};
      }
    }
  }
  
  @media (max-width: 768px) {
    padding: 1rem 2rem 2rem 2rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 50px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.8rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.8rem;
      padding: 0 12px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.8rem;
      padding: 12px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 60px;
      padding: 0 16px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem 1rem 1rem 1rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 45px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.75rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.75rem;
      padding: 0 8px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.75rem;
      padding: 8px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 50px;
      padding: 0 12px;
    }
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 2rem;
  text-align: center;
  background: linear-gradient(135deg, ${colors.white} 0%, ${colors.lightWhite} 100%);
  border-radius: 20px;
  border: 2px dashed ${colors.inputBorderWhite};
  margin: 2rem 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(36, 147, 147, 0.05) 0%, transparent 70%);
    animation: float 6s ease-in-out infinite;
  }
  
  .empty-icon {
    font-size: 5rem;
    margin-bottom: 1.5rem;
    opacity: 0.8;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    animation: bounce 2s ease-in-out infinite;
    position: relative;
    z-index: 1;
  }
  
  h3 {
    color: ${colors.text};
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 1rem 0;
    position: relative;
    z-index: 1;
    background: linear-gradient(135deg, ${colors.text}, ${colors.brown});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  p {
    color: ${colors.textMed};
    font-size: 1.1rem;
    margin: 0;
    max-width: 450px;
    line-height: 1.6;
    position: relative;
    z-index: 1;
    font-weight: 500;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
  }
  
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-10px); }
    60% { transform: translateY(-5px); }
  }
`;

const Client = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
  }
`;

const Id = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: ${colors.textBlue};
  }
  p {
    color: ${colors.textMed};
  }
`;

const Action = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  gap: 0.75rem;
  padding: 8px;
  
  div {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    background: linear-gradient(135deg, ${colors.white} 0%, ${colors.lightWhite} 100%);
    border: 1px solid ${colors.inputBorderWhite};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.1) 100%);
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      border-color: ${colors.brown};
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
    
    img {
      width: 18px;
      height: 18px;
      object-fit: contain;
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    }
  }
  
  .MuiSvgIcon-root {
    transition: all 0.3s ease;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    
    &:hover {
      transform: scale(1.1);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    }
  }
  
  // WhatsApp icon special styling
  .MuiSvgIcon-root[style*="green"] {
    &:hover {
      color: #25d366 !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(37, 211, 102, 0.3));
    }
  }
  
  // Eye icon special styling
  .MuiSvgIcon-root[style*="brown"] {
    &:hover {
      color: ${colors.brown} !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(36, 147, 147, 0.3));
    }
  }
`;

const PopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: ${(props) => (props.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  isolation: isolate;
`;

const PortalPopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1000 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  isolation: isolate !important;
  pointer-events: auto !important;
`;

const PopUp = styled.div`
  width: 95vw;
  max-width: 1200px;
  height: 85vh;
  max-height: 800px;
  overflow: hidden;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  /* Allow tooltips to appear above modal */
  .MuiDataGrid-root {
    z-index: 1 !important;
  }
  
  .MuiDataGrid-columnHeaders {
    z-index: 2 !important;
  }
  
  .MuiDataGrid-menuIcon {
    z-index: 3 !important;
  }
  
  .MuiDataGrid-columnHeaderTitle {
    z-index: 2 !important;
  }
  
  /* Ensure tooltips appear above modal */
  .MuiTooltip-popper {
    z-index: 9999 !important;
  }
`;
const NumberPopUp = styled.div`
  width: 90vw !important;
  max-width: 500px !important;
  height: auto !important;
  min-height: 500px !important;
  max-height: 85vh !important;
  overflow: hidden !important;
  background-color: ${colors.white} !important;
  display: flex !important;
  flex-direction: column !important;
  border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Cross = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  
  &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;
const Crosstask = styled.div`
  position: absolute;
  top: 10px;
  right: 2px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  
  &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;
const PopUpSection = styled.div`
  width: 100%;
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  flex: 1;
  overflow-y: auto;
  padding: 0;
  
  &.task-table-section {
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
  }
`;
const NumberPopUpSection = styled(PopUpSection)`
  flex-direction: column;
  margin: 1em;
  justify-content: center;
  line-height: 3em;
`;

const Section = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border-right: 1px solid #e0e0e0;
  height: 100%;
  
  &:last-child {
    border-right: none;
  }
`;

const Task = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1.5rem;
`;

const Heading = styled.div`
  width: 100%;
  text-align: left;
  padding: 0 0 1rem 0;
  color: ${colors.textBlue};
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 1.5rem;
`;

const InputPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    color: ${colors.text};
    margin: 0 0 0.5rem 0;
  }
`;

const InputFeild = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  h3 {
    color: ${colors.text};
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0;
  }
  p {
    color: ${colors.veryHot};
    margin-top: 0.5em;
  }
  div {
    position: relative;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    width: 100%;
    background-color: #f8f9fa;
    
    &:focus-within {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    select,
    input[type="date"] {
      background-color: transparent;
      width: 100%;
      padding: 12px 16px;
      outline: none;
      border: none;
      font-size: 0.95rem;
      color: ${colors.text};
      
      ::placeholder {
        color: #999;
      }
    }
  }
  input,
  textarea {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #f8f9fa;
    width: 100%;
    padding: 12px 16px;
    outline: none;
    font-size: 0.95rem;
    color: ${colors.text};
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    ::placeholder {
      color: #999;
    }
  }
  span {
    background-color: ${colors.inputWhite};
    padding: 1em 0em 1em 1em;
    border-radius: 5px;
    border: 1px solid ${colors.inputBorderWhite};
    display: flex;
    position: relative;
    label {
      position: absolute;
      right: 3%;
      top: 20%;
      background-color: ${colors.black};
      color: ${colors.white};
      padding: 0.5em 1em;
      border-radius: 5px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      font-size: clamp(1em, 1vh, 2em);
      color: ${colors.textMed};
    }
  }
  input[type="file"] {
    display: none;
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  gap: 1rem;
  
  .cancel-btn {
    background: #6c757d;
    color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
    
    &:hover {
      background: #5a6268;
      box-shadow: 0 8px 20px rgba(108, 117, 125, 0.3);
    }
    
    &:active {
    }
  }
  
  .save-btn {
    background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
    color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
    
    &:hover {
      box-shadow: 0 8px 20px rgba(36, 147, 147, 0.3);
    }
    
    &:active {
    }
  }
`;

const TaskLoader = styled.div`
  margin-top: 1em;
`;

const BankInputFeild = styled.div`
  width: 100%;
  h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
`;

const UploadedFile = styled.img`
  border-radius: 50%;
  margin-left: 50%;
  width: 70px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const StaffInputFeild = styled.div`
  /* width: 85%; */
  h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
`;

const AssignLeadModal = styled.div`
  width: 90vw !important;
  max-width: 500px !important;
  height: auto !important;
  min-height: 500px !important;
  max-height: 85vh !important;
  overflow: hidden !important;
  background-color: ${colors.white} !important;
  display: flex !important;
  flex-direction: column !important;
  border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
